import {
  AddressProvider,
  AppProvider,
  FormDataProvider,
  LocationProvider,
  ZipProvider,
  PrePopProvider,
  DisclaimerProvider,
  LenderProvider
} from './';

import { HelmetProvider } from 'react-helmet-async';

const CombinedProviders = ({ children }) => (
  <HelmetProvider>
    <PrePopProvider>
      <AddressProvider>
        <AppProvider>
          <LenderProvider>
            <DisclaimerProvider>
              <ZipProvider>
                <LocationProvider>
                  <FormDataProvider>{children}</FormDataProvider>
                </LocationProvider>
              </ZipProvider>
            </DisclaimerProvider>
          </LenderProvider>
        </AppProvider>
      </AddressProvider>
    </PrePopProvider>
  </HelmetProvider>
);

export default CombinedProviders;
